import FastMarquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const Marquee = ({ t }) => (
  <div data-testid="editorial-marquee" className="py-10 md:py-14 border-y border-white/5 overflow-hidden">
    <FastMarquee speed={35} gradient={false} aria-hidden="true">
      {t.marquee.map((word, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display font-black uppercase tracking-tight text-5xl md:text-7xl text-outline px-6 md:px-10">
            {word}
          </span>
          <Sparkles className="w-6 h-6 md:w-8 md:h-8 text-[#D000FF]/50 mx-2" strokeWidth={1.5} />
        </span>
      ))}
    </FastMarquee>
  </div>
);

export default Marquee;
